export const regularizacaoPerdasStyle = {}
